// Central place to resolve backend asset URLs (profile pictures, uploads, etc.).
// Reads the backend base from env so nothing is hardcoded to localhost.
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:5000";

/**
 * Resolve a server-relative asset path (e.g. "/uploads/pic.png") to an absolute
 * URL. Absolute URLs (http/https) and empty values are passed through unchanged.
 */
export function getAssetUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}
